'use strict';
module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/internals/fails.js
// module id = 46
// module chunks = 0